import {FAILURE, PENDING, SUCCESS} from '../../constants'
import {getGroupFilters as getGroupFiltersAPI} from '../../../services/groups'

export async function getGroupFilters(
  dispatch,
  {group_id, query = null, limit = null, type = null}
) {
  try {
    dispatch({type: PENDING})
    let response = await getGroupFiltersAPI({group_id, query, limit, type})

    if (!!type) {
      const _types = type.split(',')
      const data = response.filter(f => _types.indexOf(f.field_type) !== -1)

      dispatch({type: SUCCESS, payload: data})
    } else {
      dispatch({type: SUCCESS, payload: response})
    }

    dispatch({type: SUCCESS, payload: response})
  } catch (e) {
    console.log(`Get Group Filters Failed: ${group_id}`)
    dispatch({type: FAILURE, payload: e})
  }
}
